import {css} from 'emotion'
import { Colors } from '../';
import { Link } from '../typo';

export const SimpleFilterStyle = css({
  justifyContent: 'center',
  '@media (min-width: 1024px)': {
    margin: 0,
  },
  'li': {
    maxWidth: '100%',
    flexBasis: '100%',
    // margin: '0 2rem',
    '@media (min-width: 1024px)': {
      maxWidth: 'none',
      flexBasis: 'auto',
      margin: 0,
    },
    '& > a': {
      ...Link,
      display: 'block',
      padding: '0px 1.5rem',
      height: 60,
      lineHeight: '60px',
      background: Colors.extraLightGrey,
      borderRight: '1px solid #FFF',
      display: 'block',
      '@media (min-width: 1024px)': {
        width: 'auto',
        display: 'inline-block',
      },
      'span': {
        color: 'black',
      },
      'svg': {
        verticalAlign: 'text-bottom',
        marginRight: '0.5rem',
      },
      '&:hover': {
        background: Colors.lightGrey,
      },
      '&.active': {
        background: 'black',
        'span': {
          color: 'white',
        },
        'svg': {
          fill: 'white',
        }
      }
    }
  },
})


// WEBPACK FOOTER //
// ./src/styles/components/simpleFilter.js